<template>
  <CSidebar
    fixed
    :show="show"
    colorScheme="light"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none justify-content-start bg-white pl-4" to="/">
      <img src="https://evbids.blob.core.windows.net/assets/images/tesla_logo.png" class="c-sidebar-brand-full" height="45" />
      <img src="https://evbids.blob.core.windows.net/assets/images/tesla_logo.png" class="c-sidebar-brand-minimized" height="45" />
    </CSidebarBrand>

    <VUserPreview class="pl-4 pr-4 mt-4 mb-3" />

    <CRenderFunction flat :content-to-render="$options.nav"/>
  </CSidebar>
</template>
<script>
import nav from './_nav'

export default {
  name: 'TheSidebar',
  nav,
  computed: {
    show () {
      return this.$store.state.sidebarShow
    },
    minimize () {
      return this.$store.state.sidebarMinimize
    }
  }
}
</script>
